import React, { useState, useContext, useEffect } from "react";
import { Zoom, Bounce } from "react-awesome-reveal";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import SuccessByWallet from "./component/SuccessByWallet";
import SuccessPayment from "./component/SuccessPayment";
import SuccessPaymentWallet from "./component/SuccessPaymentWallet";
import UnSuccessPayment from "./component/UnSuccessPayment";
import ApiUserPayment from "../../../core/api/api.userPayment";
import { toast } from "react-toastify";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "../../../core/contexts/context.app";
import _ from "lodash";
import { Link, useLocation } from "react-router-dom";
import DottedLoadingData from "../../components/DottedLoadingData";
import { IconError } from "../../../assets/icons";
// import { ExclamationCircle } from 'react-bootstrap-icons';

function AfterPayIndex() {
  const location = useLocation();
  const [itemData, setItemData] = useState();
  const [loadingData, setLoadingData] = useState(true);
  //const params = queryString.parse(location.search);
  const params = new URLSearchParams(window.location.search);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    (async () => {
      try {
        // user : 091544444444
        // http://localhost:9000/afterPay?bid=7016&pid=15025
        //دریافت لیست نقش ها
        const response = await ApiUserPayment.getPaymentResult({
          bid: params?.get("bid"),
          pid: params?.get("pid"),
        });

        if (!_.isEmpty(response) && response.succeeded) {
          setItemData(response.data);
          setLoadingData(false);
          // در صورت تغییر مبلغ کیف پول مبلغ کیف پول ویرایش شود
          if (
            _.isNumber(response.data.userWalletRiallBalance) &&
            response.data.userWalletRiallBalance >= 0
          ) {
            //دریافت اطلاعات کاربر
            let userInfo = ServiceStorage.getUserInfo();
            if (userInfo != null) {
              userInfo.walletRiallBalance =
                response.data.userWalletRiallBalance;
              userInfo.walletAvailableRiallBalance =
                response.data.userWalletAvailableRiallBalance;
              //ویرایش اطلاعات کاربر
              ServiceStorage.setUserInfo(userInfo);
              ctx.setUserInfo(userInfo);
            }
          }
          // در صورت پرداخت سبد ، سبد از استورج پاک شود
          if (_.isNumber(response.data.basketId) && response.data.basketId > 0)
            await BasketHelper.deletebasket(ctx);
          //حذف کد تخفیف از استورج در صورت وجود داشتن
          //   if (ServiceStorage.getPromoCode() != null){
          //     ServiceStorage.removePromoCode();
          // }
          //
        } else {
          //toast.configure();
          setLoadingData(false);
          toast(response?.message);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => {};
  }, []);

  return (
    <>
      <div className=" py-4">
        {loadingData ? (
          <div className="pt-5 text-center">
            <div className="pt-5">
              <DottedLoadingData withText="true" />
            </div>
          </div>
        ) : (
          <>
            {itemData?.boxId == 1 ? (
              <div className="my-auto">
                {/* سبد پرداخت کرده در کیف پولش به اندازه کافی موجودی داشته  این خروجی */}
                <SuccessByWallet
                  basketId={itemData.basketId}
                  userPaymentId={itemData.userPaymentId}
                  amount={itemData.amount}
                  reserveId={itemData.reserveId}
                  referenceId={itemData.referenceId}
                  userWalletRiallBalance={itemData.userWalletRiallBalance}
                  errorText={itemData.errorText}
                />
              </div>
            ) : itemData?.boxId == 2 ? (
              <div className="my-auto">
                {/* سپد پرداخت کرده و موجودی کافی نداشته رفته به درگاه*/}
                <SuccessPayment
                  basketId={itemData.basketId}
                  userPaymentId={itemData.userPaymentId}
                  amount={itemData.amount}
                  reserveId={itemData.reserveId}
                  referenceId={itemData.referenceId}
                  userWalletRiallBalance={itemData.userWalletRiallBalance}
                  errorText={itemData.errorText}
                />
              </div>
            ) : itemData?.boxId == 3 ? (
              <div className="my-auto">
                {/*  در بازگشت از بانک به مشکل بر خورد کرده*/}
                <UnSuccessPayment
                  basketId={itemData.basketId}
                  userPaymentId={itemData.userPaymentId}
                  amount={itemData.amount}
                  reserveId={itemData.reserveId}
                  referenceId={itemData.referenceId}
                  userWalletRiallBalance={itemData.userWalletRiallBalance}
                  errorText={itemData.errorText}
                />
              </div>
            ) : itemData?.boxId == 4 ? (
              <div className="my-auto">
                {/* برای شارژ کیف پول بوده */}
                <SuccessPaymentWallet
                  basketId={itemData.basketId}
                  userPaymentId={itemData.userPaymentId}
                  amount={itemData.amount}
                  reserveId={itemData.reserveId}
                  referenceId={itemData.referenceId}
                  userWalletRiallBalance={itemData.userWalletRiallBalance}
                  errorText={itemData.errorText}
                />
              </div>
            ) : (
              <Container
                className="my-auto text-center"
                style={{ maxWidth: "500px" }}
              >
                <Card
                  className="rounded-4  shadow-sm"
                  style={{ border: "1px solid #f9e3e8" }}
                >
                  <Card.Header
                    className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
                    style={{ background: "#f9e3e8" }}
                  >
                    <IconError fillColor="red" />
                    <div className="text-danger fw-bold fs-103 mt-2">
                      عملیات ناموفق{" "}
                    </div>
                    <div className="text-danger mt-1 fs-08">
                      عملیات موردنظر انجام نشد.
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row className="py-4">
                      <Col>مشکلی پیش امده لطفا با پشتیبانی تماس بگیرید.</Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="border-top-0 rounded-bottom-4 py-3">
                    <Link to="/contact">
                      <Button
                        className="px-4 fs-085 rounded-pill"
                        variant="outline-danger"
                      >
                        تماس با پشتیبانی
                      </Button>
                    </Link>
                  </Card.Footer>
                </Card>
              </Container>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default AfterPayIndex;
